<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error': showError}">
        <div class="info">{{ 'global.infoRequired' | translate}}</div>
            <div class="entry-4-modal">
                <label>{{'global.pais' | translate}} *</label>
                <input type="text" formControlName="pais">
            </div>
            <div class="entry-4-modal">
                <label>{{'mantenimientoPaises.table.isO3' | translate}} *</label>
                <input type="text" formControlName="isO3">
            </div>
            <div class="entry-4-modal">
                <label>{{'mantenimientoPaises.table.timezone' | translate}} *</label>
                <app-filterable-list class="short-list" [itemsList]="timezones" [selectedItem]="newEditForm.get('timezone')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div class="entry-4-modal">
                <label>{{'mantenimientoPaises.table.alias' | translate}}</label>
                <input type="text" formControlName="desPaisAlias">
            </div>
            <div class="entry-4-modal alignment-start">
                <input type="checkbox" id="esProductorModal" value="false" formControlName="esProductorModal">
                <label for="esProductorModal">{{'mantenimientoPaises.table.productor' | translate}} *</label>
            </div>
            <div class="entry-4-modal alignment-start">
                <input type="checkbox" id="esDestinoModal" value="false" formControlName="esDestinoModal">
                <label for="esDestinoModal">{{'mantenimientoPaises.table.destino' | translate}} *</label>
            </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{paisId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>
